// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  rowId: __t.u64().primaryKey().name("row_id"),
  assetId: __t.u64().name("asset_id"),
  renditionId: __t.u64().name("rendition_id"),
  canonicalId: __t.u64().name("canonical_id"),
  nodePath: __t.string().name("node_path"),
  translateX: __t.f64().name("translate_x"),
  translateY: __t.f64().name("translate_y"),
  translateZ: __t.f64().name("translate_z"),
  rotateX: __t.f64().name("rotate_x"),
  rotateY: __t.f64().name("rotate_y"),
  rotateZ: __t.f64().name("rotate_z"),
  rotateW: __t.f64().name("rotate_w"),
  scaleX: __t.f64().name("scale_x"),
  scaleY: __t.f64().name("scale_y"),
  scaleZ: __t.f64().name("scale_z"),
});
